"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "ui:layout": "section",
  "ui:title": "Bakgrunnsinformasjon",
  "ui:label": false,
  "ui:options": {
    "grid": true,
    "spacing": 2,
    "collapsible": true
  },
  "ui:fieldset": ["circumstance", "circumstanceDetails", "occuredAt"],
  "circumstance": {
    "ui:title": "Vet du når eller hvorfor avviket oppstod?",
    "ui:widget": "radio",
    "ui:inline": true
  },
  "circumstanceDetails": {
    "ui:title": "Beskrivelse av årsak",
    "ui:widget": "textarea",
    "ui:help": "Hva har skjedd? Hvorfor?"
  },
  "occuredAt": {
    "ui:title": "Inntraff dato",
    "ui:help": "Når oppstod avviket?"
  }
};
exports.default = _default;
module.exports = exports.default;